import { Flex, Select } from 'antd';

import { CustomInputNumber } from '@app/components';
import { PREFIX } from '@app/constants';
import {
  SALARY_PERCENT,
  SALARY_TYPE_SELECT_OPTIONS,
} from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/ServiceSalaryComponent/data';
import { useServiceSalaryComponent } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/ServiceSalaryComponent/hooks';
import type { ServiceSalaryComponentProps } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/ServiceSalaryComponent/types';

import '@pages/Employees/EditEmployee/components/ClientServicesTab/components/ServiceSalaryComponent/styles/ServiceSalaryComponent.desktop.scss';

export const ServiceSalaryComponent = ({
  onSalaryTypeSelect,
  serviceId,
  onSalaryValueChange,
  defaultSalaryAmount,
  defaultSalaryFormat,
}: ServiceSalaryComponentProps) => {
  const {
    handleSAlaryTypeChange,
    getSalaryIcon,
    salaryType,
    handleSAlaryValueChange,
  } = useServiceSalaryComponent({
    onSalaryTypeSelect,
    serviceId,
    onSalaryValueChange,
    defaultSalaryFormat,
  });

  return (
    <div className={`${PREFIX}service-salary-component`}>
      <Flex gap={16}>
        <Select
          className="salary-type-select"
          options={SALARY_TYPE_SELECT_OPTIONS}
          onChange={handleSAlaryTypeChange}
          defaultValue={defaultSalaryFormat}
          size="large"
          value={salaryType}
        />
        <CustomInputNumber
          className="salary-value"
          addonAfter={getSalaryIcon()}
          disabled={salaryType === undefined}
          onSuccess={({ value }) => {
            handleSAlaryValueChange(value);
          }}
          inputValue={defaultSalaryAmount}
          size="large"
          style={{ maxWidth: '140px' }}
          isAllowed={(value) =>
            salaryType === SALARY_PERCENT ? value >= 0 && value <= 100 : true
          }
        />
      </Flex>
    </div>
  );
};
